<template>
  <b-card>
    <template v-slot:header>
      <div class="d-flex justify-content-between">
        <div>
          <!-- Subtitle -->
          <h6 class="surtitle">Profit & Loss</h6>
          <!-- Title -->
          <h5 class="h3 mb-0">Income</h5>
        </div>
        <b-button-group>
          <b-button :variant="type == 'amount' ? 'primary' : 'outline-primary'" @click="type = 'amount'">$</b-button>
          <b-button :variant="type == 'percent' ? 'primary' : 'outline-primary'" @click="type = 'percent'">%</b-button>
        </b-button-group>
      </div>
    </template>
    <div class="chart-area">
      <pie-chart
        id="pie-chart"
        :height="350"
        :chart-data="pieChart.chartData"
        :extra-options="pieChart.extraOptions"
      >
      </pie-chart>
    </div>
  </b-card>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import PieChart from '@/components/Charts/PieChart';
import * as chartConfigs from '@/components/Charts/config';
import { Charts } from '@/components/Charts/config';
import {Select, Option} from 'element-ui';

export default {
  mixins: [errorsMixin],
  components: {
    PieChart,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    userRoute: null,
    year: null,
    month: null,
    quarter: null,
  },
  data() {
    return {
      type: 'amount',
      amounts: [],
      percents: [],
      pieChart: {
        chartData: {
          labels: [],
          datasets: [{
            data: [],
            backgroundColor: ['#3D5F71', '#6F91A5', '#EF972C'],
            label: ''
          }],
        },
        extraOptions: {
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var dataLabel = data.labels[tooltipItem.index];
                var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString("en-US", {style:"currency", currency:"USD"});

                if (Chart.helpers.isArray(dataLabel)) {
                  dataLabel = dataLabel.slice();
                  dataLabel[0] += value;
                } else {
                  dataLabel += value;
                }

                return dataLabel;
              }
            }
          },
        }
      },
    }
  },
  methods: {
    async getChartData() {
      await axios.get(this.userRoute + "/reports/profit-loss/income-chart?year=" + this.year + "&month=" + this.month + "&quarter=" + this.quarter)
      .then(response => {
        this.amounts = response.data['amount'];
        this.percents = response.data['percent'];
        if (this.type == 'amount') {
          this.updateChartData(this.amounts);
        } else {
          this.updateChartData(this.percents);
        }
      })
      .catch(error => {
        this.error(error);
      });
    },
    updateChartData(chartData) {
      this.pieChart.chartData = {
        labels: [
          'Listing Income',
          'Buyer Income',
          'Transaction Fees',
        ],
        datasets: [{
          label: 'Income %',
          backgroundColor: ['#3D5F71', '#6F91A5', '#EF972C'],
          data: chartData
        }]
      }
    },
    updateChartOptions(chartType) {
      this.pieChart.extraOptions = {
        responsive: true,
        animation: {
          animateScale: true,
          animateRotate: true
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var dataLabel = data.labels[tooltipItem.index];
              if (chartType == 'amount') {
                var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString("en-US", {style:"currency", currency:"USD"});
              } else {
                var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed() + '%';
              }

              if (Chart.helpers.isArray(dataLabel)) {
                dataLabel = dataLabel.slice();
                dataLabel[0] += value;
              } else {
                dataLabel += value;
              }

              return dataLabel;
            }
          }
        }
      }
    }
  },
  created() {
    this.getChartData();
  },
  watch: {
    type(to, from) {
      if (to == 'amount') {
        this.updateChartData(this.amounts);
      } else {
        this.updateChartData(this.percents);
      }

      this.updateChartOptions(to);
    },
    year(to, from) {
      this.getChartData();
    },
    month(to, from) {
      this.getChartData();
    },
    quarter(to, from) {
      this.getChartData();
    }
  }
};
</script>